import { useRef } from 'react'

export const useMarketingTaskFormRefs = () => {
  const step0Ref = useRef<HTMLDivElement>(null)
  const step1Ref = useRef<HTMLDivElement>(null)
  const step2Ref = useRef<HTMLDivElement>(null)
  const step3Ref = useRef<HTMLDivElement>(null)
  const step4Ref = useRef<HTMLDivElement>(null)
  const step5Ref = useRef<HTMLDivElement>(null)
  const step6Ref = useRef<HTMLDivElement>(null)
  const step7Ref = useRef<HTMLDivElement>(null)
  const step8Ref = useRef<HTMLDivElement>(null)
  const stepRefs = [step0Ref, step1Ref, step2Ref, step3Ref, step4Ref, step5Ref, step6Ref, step7Ref, step8Ref]
  const rawSteps = [
    {
      title: 'Select Organization',
      description:
        'Select the organization you wish to create a task for.  This will create a perpetual connection between the task and the organization until the task is deleted',
    },
    {
      title: 'Type',
      options: [
        'Updates',
        'Review / Audit',
        'Budget',
        'Create / Setup',
        'New Client Onboard',
        'Campaign Checklists',
        'Ad Approvals',
        'Pause',
        'Enable',
      ],
      description:
        'List of options representing the type of deal being created (Marketing Services Agreement (MSA), Creative Services Agreement (CSA), etc..',
    },

    {
      title: 'Requested By',
      options: ['Internal', 'External'],
      description: '',
    },
    {
      title: 'Request Type',
      options: ['Issue', 'Observation', 'Request', 'Other'],
      description: '',
    },
    {
      title: 'Assignee(s)',
      description: 'This field is used to assign the team members responsible for carrying out the task.',
    },
    {
      title: 'Channel',
      description:
        'Based on the type selected, choose the appropriate channel(s) related to the task you are creating.  This is a multiselect field.',
    },
    {
      title: 'Platform',
      description:
        'Based on the channel(s) selected, a list will populate with choices for the platform you wish to use for the task.  This is a multiselect field.',
    },
    {
      title: 'Options',
      description:
        'Based on the platform(s) selected, choose the options from the list populated.  Each option selected will create a new subtask inside of the new task.  You will also have the option whether to create then or not on the next page.',
    },
    {
      title: 'Next',
      description: 'Navigate to the next page for subtask selection / deselection.',
    },
  ]
  const marketingTaskFormSteps = rawSteps.map((step, index) => ({ ...step, stepIndex: index }))
  return {
    step0Ref,
    step1Ref,
    step2Ref,
    step3Ref,
    step4Ref,
    step5Ref,
    step6Ref,
    step7Ref,
    step8Ref,
    stepRefs,
    marketingTaskFormSteps,
  }
}
